
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_43348","data-name":"Group 43348","xmlns":"http://www.w3.org/2000/svg","width":"15.628","height":"15.628"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-tool-home"}},[_c('rect',{attrs:{"id":"Rectangle_14274","data-name":"Rectangle 14274","width":"15.628","height":"15.628","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_43347","data-name":"Group 43347","clip-path":"url(#clip-path-tool-home)"}},[_c('path',{attrs:{"id":"Path_29730","data-name":"Path 29730","d":"M2.266.75h11.1a1.516 1.516 0 011.516 1.516v11.1a1.515 1.515 0 01-1.516 1.515h-11.1A1.515 1.515 0 01.75 13.363V2.266A1.516 1.516 0 012.266.75","fill":"#fff"}}),_c('path',{attrs:{"id":"Rectangle_14273","data-name":"Rectangle 14273","d":"M2.266.75h11.1a1.516 1.516 0 011.516 1.516v11.1a1.515 1.515 0 01-1.515 1.515H2.266A1.516 1.516 0 01.75 13.362V2.266A1.516 1.516 0 012.266.75z","fill":"none","stroke":"#5a677d","stroke-width":"1.5"}}),_c('line',{attrs:{"id":"Line_1321","data-name":"Line 1321","y2":"14.128","transform":"translate(6.239 .75)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1.5"}}),_c('line',{attrs:{"id":"Line_1322","data-name":"Line 1322","x1":"1.821","transform":"translate(2.516 3.804)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1.5"}}),_c('line',{attrs:{"id":"Line_1323","data-name":"Line 1323","x1":"1.821","transform":"translate(2.516 6.083)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    